import React from 'react'

import bg1 from '../assets/images/hero/ss1.jpg'
import bg2 from '../assets/images/hero/ss2.jpg'
import bg3 from '../assets/images/hero/ss3.jpg'
import bg4 from '../assets/images/hero/ss4.jpg'
// import bg5 from '../assets/images/hero/slide5.jpg'
// import bg6 from '../assets/images/hero/slide6.jpg'
// import icon1 from '../assets/images/branding/icon2.png'
// import icon2 from '../assets/images/branding/icon1.png'
import icon3 from '../assets/images/branding/icon6.png'
// import icon4 from '../assets/images/branding/icon4.png'
import { Link } from 'react-router-dom'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

export default function HomeBanner() {
    return (
        <>
            <section className="swiper-slider-hero position-relative d-block vh-100" id="home">
                <div className="swiper-container">
                    <Swiper className="swiper-wrapper"
                        speed={2000}
                        modules={[Autoplay,]}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                    >

                        <SwiperSlide className="swiper-slide d-flex align-items-center overflow-hidden">
                            <div className="slide-inner slide-bg-image d-flex align-items-center" style={{ backgroundImage: `url(${bg2})`, backgroundPosition: 'center' }}>
                                <div className="bg-overlay"></div>
                                <div className="container">
                                    <div className="row justify-content-center mt-5">
                                        <div className="col-12">
                                            <div className="title-heading text-center text-md-start">
                                                <img src={icon3} className="img-fluid slidericon" alt="" />
                                                <h1 className="heading text-white title-dark fw-bold mb-4 text-capitalize">Calidez</h1>
                                                <p className="para-desc text-white-50">
                                                    Ofrecemos atención médica con calidez y un trato humano.
                                                </p>
                                                <div className="mt-4 pt-2">
                                                    <Link to="/quienessomos" className="btn btn-success">Quiénes somos</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide className="swiper-slide d-flex align-items-center overflow-hidden">
                            <div className="slide-inner slide-bg-image d-flex align-items-center" style={{ backgroundImage: `url(${bg1})`, backgroundPosition: 'center' }}>
                                <div className="bg-overlay"></div>
                                <div className="container">
                                    <div className="row justify-content-center mt-5">
                                        <div className="col-12">
                                            <div className="title-heading text-center text-md-start">
                                                <img src={icon3} className="img-fluid slidericon" alt="" />
                                                <h1 className="heading text-white title-dark fw-bold mb-4 text-capitalize">Experiencia</h1>
                                                <p className="para-desc text-white-50">
                                                    Nuestra experiencia garantiza un cuidado médico preciso y confiable.
                                                </p>
                                                <div className="mt-4 pt-2">
                                                    <Link to="/directorio" className="btn btn-success">Directorio médico</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide className="swiper-slide d-flex align-items-center overflow-hidden">
                            <div className="slide-inner slide-bg-image d-flex align-items-center" style={{ backgroundImage: `url(${bg3})`, backgroundPosition: 'center' }}>
                                <div className="bg-overlay"></div>
                                <div className="container">
                                    <div className="row justify-content-center mt-5">
                                        <div className="col-12">
                                            <div className="title-heading text-center text-md-start">
                                                <img src={icon3} className="img-fluid slidericon" alt="" />
                                                <h1 className="heading text-white title-dark fw-bold mb-4 text-capitalize">Vanguardia</h1>
                                                <p className="para-desc text-white-50">
                                                    Tecnología de vanguardia para diagnósticos rápidos y eficaces.
                                                </p>
                                                <div className="mt-4 pt-2">
                                                    <Link to="/tecnologia" className="btn btn-success">Conocer más</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide className="swiper-slide d-flex align-items-center overflow-hidden">
                            <div className="slide-inner slide-bg-image d-flex align-items-center" style={{ backgroundImage: `url(${bg4})`, backgroundPosition: 'center' }}>
                                <div className="bg-overlay"></div>
                                <div className="container">
                                    <div className="row justify-content-center mt-5">
                                        <div className="col-12">
                                            <div className="title-heading text-center text-md-start">
                                                <img src={icon3} className="img-fluid slidericon" alt="" />
                                                <h1 className="heading text-white title-dark fw-bold mb-4 text-capitalize">Integrales</h1>
                                                <p className="para-desc text-white-50">
                                                    Brindamos soluciones integrales que cubren todas tus necesidades de salud.
                                                </p>
                                                <div className="mt-4 pt-2">
                                                    <Link to="/servicios" className="btn btn-success">Conocer más</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </section>
        </>
    )
}
